export const Patterns = {
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)((?=.*[?!@#$%^&*()`~|"'/\-_=+{};:,<.>]){1})\S{8,}$/,
  digits: /^[0-9]+$/,
  alphabets: /^[A-Za-z ]*$/,
}

export const format = process.env.REACT_APP_FORMAT ? process.env.REACT_APP_FORMAT : 'dd MMMM yyyy'
